export default __webpack_public_path__ + "static/media/lap-top-bottom.6ef0bfaf.svg";